// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration object using environment variables
const firebaseConfig = {
  apiKey: "AIzaSyDhVLc796iw5GE3myyVNFCi3q1H02iisME",
  authDomain: "ocean-hazard-reporter.firebaseapp.com",
  projectId: "ocean-hazard-reporter",
  storageBucket: "ocean-hazard-reporter.firebasestorage.app",
  messagingSenderId: "826466467",
  appId: "1:826466467:web:669ec6b0cfb55053cf5f16",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Configure authentication providers
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export const githubProvider = new GithubAuthProvider();
githubProvider.setCustomParameters({
  prompt: "select_account",
});

// Add scopes for better user information
googleProvider.addScope("profile");
googleProvider.addScope("email");

githubProvider.addScope("user:email");

export default app;
